import { useState, useEffect } from 'react'
import { DailyBalance24Object } from '../components/CompactTable/CompactTable'
import { getPatientView24 } from '../core/api/get-patient-view-24'
import { Patient } from '../core/entities/patient.entity'

export function usePatientData24(patient: Patient | null) {
  const [patientViewData, setPatientViewData] =
    useState<DailyBalance24Object | null>(null)
  const [patientViewError, setPatientViewError] = useState<Error | null>(null)

  useEffect(() => {
    if (!patient) return

    const controller = new AbortController()

    getPatientView24(patient.patientId, controller.signal)
      .then((response) => response.data)
      .then(setPatientViewData)
      .catch(setPatientViewError)

    return () => {
      controller.abort()
    }
  }, [patient])

  return {
    patientViewData,
    patientViewError
  }
}
